var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V4.25H22C22.4142 4.25 22.75 4.58579 22.75 5C22.75 5.41421 22.4142 5.75 22 5.75H20.0909L21.8426 10.1433C21.9366 10.3789 21.9927 10.6316 21.9606 10.8832C21.7724 12.3591 20.5119 13.5 18.9848 13.5C17.4578 13.5 16.1973 12.3591 16.0091 10.8832C15.977 10.6315 16.0331 10.3789 16.1271 10.1433L17.8787 5.75H12.75V21.25H17C17.4142 21.25 17.75 21.5858 17.75 22C17.75 22.4142 17.4142 22.75 17 22.75H7C6.58579 22.75 6.25 22.4142 6.25 22C6.25 21.5858 6.58579 21.25 7 21.25H11.25V5.75H6.10602L7.85774 10.1433C7.95171 10.3789 8.00782 10.6316 7.97573 10.8832C7.78756 12.3591 6.527 13.5 4.99998 13.5C3.47295 13.5 2.21239 12.3591 2.02422 10.8832C1.99214 10.6315 2.04824 10.3789 2.1422 10.1433L3.89386 5.75H2C1.58579 5.75 1.25 5.41421 1.25 5C1.25 4.58579 1.58579 4.25 2 4.25H11.25V2C11.25 1.58579 11.5858 1.25 12 1.25ZM6.40388 10.5L4.99993 7.19463L3.59607 10.5H6.40388ZM18.9848 7.19463L17.5809 10.5H20.3887L18.9848 7.19463Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.6c89de537149b650e219a26938edf072.svg";
export { ForwardRef as ReactComponent };